import PortugalContractType from '../../models/PortugalContractType'
import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class ContractTypes extends PayrollLegalEntityResource<PortugalContractType> {
  get cacheKey(): string {
    return 'portugalContractTypes'
  }

  model() {
    return PortugalContractType
  }
}

export { ContractTypes }
